<template>
  <SectionPageShell
    section="packages"
    title="Paket bearbeiten"
    show-back-link
  >
    <p class="text-muted mb-0">
      Bearbeitung für Paket #{{ $route.params.id }} wird hier als Nächstes eingebunden.
    </p>
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";

export default {
  name: "PackagesEdit",
  components: {
    SectionPageShell,
  },
}
</script>
